<template>
    <div>
        <v-form
                ref="form"
                v-model="valid"
                lazy-validation
        >
            <v-container fluid>
                <v-row>
                    <v-col cols="8">
                        <v-row>
                            <v-col cols="12">
                                <v-card>
                                    <v-toolbar color="indigo" dark flat dense>
                                        <v-toolbar-title>Contact</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-form-base :col="12" :model="trainer" :schema="schemaContact"/>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12">
                                <v-card>
                                    <v-toolbar color="indigo" dark flat dense>
                                        <v-toolbar-title>Resources</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-form-base :col="12" :model="trainer" :schema="schemaResources"/>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12">
                                <v-card>
                                    <v-toolbar color="indigo" dark flat dense>
                                        <v-toolbar-title>Notes</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-form-base :col="12" :model="trainer" :schema="schemaNotes"/>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="4">
                        <v-row>
                            <v-col cols="12">
                                <v-card>
                                    <v-toolbar color="indigo" dark flat dense>
                                        <v-toolbar-title>Flags</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-form-base :col="12" :model="trainer" :schema="schemaFlags"/>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12">
                                <v-card>
                                    <v-toolbar color="indigo" dark flat dense>
                                        <v-toolbar-title>Feeds</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-form-base :col="12" :model="trainer" :schema="schemaFeeds"/>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>

<script>
    import VFormBase from 'vuetify-form-base';

    const required = msg => v => !!v || msg
    const validEmail = msg => v =>  !v || /.+@.+\..+/.test(v) || msg

    export default {
        components: {
            VFormBase
        },
        props: {
            trainer: {
                type: Object,
            },
        },
        computed: {
            schemaContact() {
                return {
                    firstName: {
                        type: 'text',
                        label: 'Fist Name',
                        col: {cols: 6},
                        require: true,
                        rules: [
                            required('First Name is required')
                        ],
                    },
                    lastName: {
                        type: 'text',
                        label: 'Last Name',
                        col: {cols: 6},
                        require: true,
                        rules: [
                            required('Last Name is required')
                        ],
                    },
                    phoneMobile: {type: 'text', label: 'Phone Mobile', col: {cols: 6}},
                    phoneHome: {type: 'text', label: 'Phone Home', col: {cols: 6}},
                    email: {
                        type: 'email',
                        label: 'E-mail',
                        col: {cols: 6},
                        rules: [
                            validEmail('E-mail must be valid')
                        ],
                    },
                    emailAlternate: {
                        type: 'email',
                        label: 'E-mail Alternate',
                        col: {cols: 6},
                        rules: [
                            validEmail('E-mail Alternate must be valid')
                        ],
                    },
                    homeStreet: {type: 'text', label: 'Street'},
                    homeTown: {type: 'text', label: 'Town', col: {cols: 6}},
                    homePostCode: {type: 'text', label: 'Postcode', col: {cols: 6}},
                }
            },

            schemaResources() {
                return {
                    calendarUrl: {type: 'text', label: 'Calendar URL'},
                    website: {type: 'text', label: 'Website URL'},
                }
            },

            schemaNotes() {
                return {
                    rates: {type: 'textarea', label: 'Rates'},
                    skills: {type: 'textarea', label: 'Skills'},
                    notes: {type: 'textarea', label: 'Other Notes'},
                }
            },

            schemaFeeds() {
                return {
                    iCalUrl: {type: 'text', label: 'iCal Feed', readonly: true},
                }
            },
            schemaFlags() {
                return {
                    freelance: {type: 'checkbox', label: 'Freelance'},
                    preferred: {type: 'checkbox', label: 'Preferred'},
                }
            },
        },
        methods: {
            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            resetValidation () {
                this.$refs.form.resetValidation()
            },
            isValid() {
                return this.valid
            },
        },
    }
</script>

<style scoped>

</style>